"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createI18nServiceInstance = void 0;
const axios_1 = __importDefault(require("axios"));
const sonic_feature_hub_tools_1 = require("@volkswagen-onehub/sonic-feature-hub-tools");
const I18NServiceV1Implementation = (i18nEndpointUrl, locale, logger) => {
    const registry = (0, sonic_feature_hub_tools_1.Registry)();
    const urlLoaders = new Map();
    const fetchMessages = (url) => {
        logger.debug(`[audi-i18n-service] loading ${url}`);
        if (url) {
            if (!urlLoaders.has(url)) {
                logger.debug(`[audi-i18n-service] already loading ${url}`);
                urlLoaders.set(url, new Promise((resolve) => {
                    axios_1.default
                        .get(url)
                        .then((result) => {
                        if (result.status === 200) {
                            logger.debug(`[audi-i18n-service] successfully loaded ${url}`);
                            resolve(result.data);
                        }
                        else {
                            throw new Error(`response status: ${result.status}`);
                        }
                    })
                        .catch((err) => {
                        logger.error(`[audi-i18n-service] error loading ${url} - ${err.message}`);
                        resolve({});
                    });
                }));
            }
            return urlLoaders.get(url) || Promise.resolve({});
        }
        return Promise.resolve({});
    };
    const setMessages = async () => {
        const messages = registry.getPayload();
        if (!(messages === null || messages === void 0 ? void 0 : messages[locale])) {
            const fetchedMessages = await fetchMessages(i18nEndpointUrl);
            const registryData = {
                [locale]: fetchedMessages,
            };
            if (!(messages === null || messages === void 0 ? void 0 : messages.default)) {
                registryData.default = fetchedMessages;
            }
            registry.update(registryData);
        }
    };
    return {
        create: (consumerId) => {
            const subscription = registry.subscribe(consumerId);
            return {
                featureService: {
                    registerCallback: async (callback) => {
                        await setMessages();
                        subscription.register(callback);
                    },
                    getMessages: registry.getPayload,
                    setLocale: async () => {
                        // deprecated
                        await setMessages();
                    },
                    setScopes: () => {
                        // do nothing
                    },
                },
                unbind: subscription.unregister,
            };
        },
    };
};
const createI18nServiceInstance = (i18nBaseUrl, i18nTenant, i18nAppId, localeService, logger) => {
    const i18nEndpointUrl = `${i18nBaseUrl}${i18nTenant}_${i18nAppId}_${localeService.language}.json`;
    return I18NServiceV1Implementation(i18nEndpointUrl, localeService.language, logger).create("local").featureService;
};
exports.createI18nServiceInstance = createI18nServiceInstance;
//# sourceMappingURL=oadd-i18n-service.js.map